import { StoreGroup } from "../../../types/app/storeGroupsTypes";
import { useMemo, useState } from "react";

interface StoreTypeAvatarProps {
  group: StoreGroup;
}

const FALLBACK_COLORS = [
  { background: "#F6AFAF", color: "#911919" },
  { background: "#FDE6B4", color: "#8A5300" },
  { background: "#CBE8FF", color: "#155B9C" },
  { background: "#D5F5E3", color: "#166534" },
  { background: "#E6DCFF", color: "#5B21B6" },
  { background: "#FCE3F0", color: "#9D174D" },
];

export const getStoreTypeInitial = (name: string | null) => {
  const trimmedName = name?.trim() || "";

  return trimmedName ? trimmedName.charAt(0).toUpperCase() : "?";
};

const getColorSeed = (group: Pick<StoreGroup, "id" | "name">) => {
  const seedInput = `${group.id}-${group.name || ""}`;
  let hash = 0;

  for (let index = 0; index < seedInput.length; index += 1) {
    hash = (hash * 31 + seedInput.charCodeAt(index)) >>> 0;
  }

  return hash;
};

export const getStoreTypeFallbackColors = (
  group: Pick<StoreGroup, "id" | "name">
) => {
  const colorIndex = getColorSeed(group) % FALLBACK_COLORS.length;

  return FALLBACK_COLORS[colorIndex];
};

const StoreTypeAvatar = ({ group }: StoreTypeAvatarProps) => {
  const [hasImageError, setHasImageError] = useState(false);
  const shouldShowImage = !!group.logoUrl && !hasImageError;
  const fallbackColors = useMemo(() => getStoreTypeFallbackColors(group), [group]);

  if (shouldShowImage) {
    return (
      <div className="store-type-avatar image">
        <img
          src={group.logoUrl || ""}
          alt={group.name || "Store type"}
          onError={() => setHasImageError(true)}
        />
      </div>
    );
  }

  const { background, color } = fallbackColors;

  return (
    <div
      className="store-type-avatar fallback"
      style={{ backgroundColor: background, color }}
      aria-hidden="true"
    >
      {getStoreTypeInitial(group.name)}
    </div>
  );
};

export default StoreTypeAvatar;
